import copyData from "copy-to-clipboard";
import styles from "./index.less";
import { ReactComponent as Delete } from "../assets/imgs/material/delete-item-icon.svg";
import { ReactComponent as Modify } from "../assets/imgs/material/modify.svg";
import { ReactComponent as EditNameIcon } from "../assets/imgs/material/edit-name.svg";
import { ReactComponent as CopyIcon } from "../assets/imgs/material/copy.svg";
import { ReactComponent as CopySuccessIcon } from "../assets/imgs/material/copy-success.svg";
import icon_txt from "../assets/imgs/material/icon_txt.png";
import icon_xls from "../assets/imgs/material/icon_xls.png";
import icon_doc from "../assets/imgs/material/icon_doc.png";
import icon_pdf from "../assets/imgs/material/icon_pdf.png";
import icon_mp3 from "../assets/imgs/material/icon_mp3.png";
import icon_unknow from "../assets/imgs/material/icon_unknow.png";
import checkedIcon from "../assets/imgs/material/checked.svg";
import uncheckIcon from "../assets/imgs/material/uncheck-icon.svg";
import uncheckHoverIcon from "../assets/imgs/material/uncheck-hover-icon.svg";
import classNames from "classnames";
import { Input, InputRef, message, Tooltip, Upload } from "antd";
import { useRef, useState } from "react";
import { getMaterialAccessListByType } from "./materialValidate";
import { MaterialType } from "../FlowEditPage/services/material";
import { MaterialTypeEnum } from "../FlowEditPage/services/template";
import ImageToggle from "../ImageToggle";
type MaterialCardProps = {
  /** 当前素材是否被选中 */
  checked: boolean;
  /** 鼠标不经过卡片也可以展示为选中按钮 */
  showUncheckButton: boolean;
  material: MaterialType;
  /** 传false则固定不显示删除按钮、否则鼠标经过卡片则显示按钮 */
  showDeleteButton?: boolean;
  /** 更改选中状态 */
  onChange: (id: string, item: MaterialType) => void;
  onPreview?: (id: string) => void;
  onDelete?: (id: string) => void;
  /** 修改素材名字或者链接 */
  onModify?: (data: {
    id: string;
    url?: string;
    name?: string;
  }) => Promise<void>;
  /** 限制素材类型 */
  type?: MaterialTypeEnum;
  /** 能否修改名称，默认可以 */
  canEditName?: boolean;
  /** 显示复制名称按钮 */
  showCopyButton: boolean;
};

const MaterialCard: React.FC<MaterialCardProps> = ({
  checked,
  showUncheckButton,
  material,
  showDeleteButton = true,
  onChange,
  onPreview,
  onDelete,
  onModify,
  type,
  canEditName = true,
  showCopyButton,
}) => {
  const { id, url, name } = material;
  const isImage = /\.(jpg|jpeg|png|gif|bmp)$/i.test(url);
  const isVideo = /\.(mp4)$/i.test(url);
  const [isEdit, setIsEdit] = useState(false);
  const [editInputValue, setEditInputValue] = useState("");
  const [copySuccess, setCopySuccess] = useState(false);
  const inputRef = useRef<InputRef>(null);
  const getFileTypeIcon = (url: string) => {
    if (isImage) {
      return url;
    }
    const fileExtension = url?.split(".")?.pop()?.toLowerCase() || "UNKNOWN";
    const fileTypeIconMap = {
      txt: icon_txt,
      csv: icon_txt,
      doc: icon_doc,
      docx: icon_doc,
      xls: icon_xls,
      xlsx: icon_xls,
      pdf: icon_pdf,
      mp3: icon_mp3,
      wav: icon_mp3,
    } as Record<string, any>;
    return fileTypeIconMap[fileExtension] ?? icon_unknow;
  };
  const accessList = getMaterialAccessListByType(type || MaterialTypeEnum.File);
  /** 切换为编辑状态 */
  const editName = () => {
    if (!canEditName) return;
    setIsEdit(true);
    setEditInputValue(name);
    setTimeout(() => {
      inputRef.current?.focus({
        cursor: "all",
      });
    }, 0);
  };
  /** 修改素材名称 */
  const modifyName = async () => {
    await (editInputValue &&
      editInputValue !== name &&
      onModify?.({ id, name: editInputValue }));
    setIsEdit(false);
    setEditInputValue("");
  };
  return (
    <div className={styles["material-card"]}>
      <div
        className={classNames(styles.buttons, {
          [styles.active]: checked,
        })}
      >
        {isVideo ? (
          <video
            className={styles.backgroundImage}
            onClick={() => {
              onPreview?.(id);
            }}
          >
            <source src={url} type="video/mp4" />
          </video>
        ) : (
          <img
            src={getFileTypeIcon(url)}
            className={styles.backgroundImage}
            onClick={() => {
              onPreview?.(id);
            }}
          />
        )}

        {!checked && (
          <ImageToggle
            className={classNames(
              styles.icon,
              styles["icon-left"],
              styles.check,
              {
                [styles["hover-show"]]: !showUncheckButton,
              }
            )}
            onClick={() => {
              onChange(id, material);
            }}
            defaultImage={uncheckIcon}
            hoverImage={uncheckHoverIcon}
          />
        )}

        {checked && (
          <ImageToggle
            className={classNames(
              styles.icon,
              styles["icon-left"],
              styles.check
            )}
            onClick={() => {
              onChange(id, material);
            }}
            defaultImage={checkedIcon}
            hoverImage={checkedIcon}
          />
        )}
        {showDeleteButton && (
          <Upload
            accept={accessList.map((ext) => `.${ext}`).join(",")}
            beforeUpload={(file) => {
              const typeVerify = accessList.includes(
                file.name
                  .substring(file.name.lastIndexOf(".") + 1)
                  .toLowerCase()
              );
              if (!typeVerify) {
                message.error(
                  `文件仅支持类型：支持类型：${accessList
                    .map((item) => `.${item}`)
                    .join("/")}`
                );
                return Upload.LIST_IGNORE;
              }
              // const maxSize = 30 * 1024 * 1024;
              // if (file.size > maxSize) {
              //   message.error(`文件大小不能超过 ${maxSize / 1024 / 1024}MB!`);
              //   return Upload.LIST_IGNORE;
              // }
              return true;
            }}
            onChange={(info) => {
              if (info.file.status === "done") {
                if (info?.file?.response?.data) {
                  onModify?.({ id, url: info.file.response.data });
                } else {
                  message.error("上传文件失败");
                }
              } else if (info.file.status === "error") {
                message.error("上传文件失败");
              }
            }}
            maxCount={1}
            action="/api/knowledge-base-management/material/import"
            showUploadList={false}
          >
            <Tooltip title="替换素材" color="#2D3253E6">
              <Modify
                className={classNames(
                  styles.icon,
                  styles["icon-right"],
                  styles.modify,
                  styles["hover-show"]
                )}
              />
            </Tooltip>
          </Upload>
        )}
        {showDeleteButton && (
          <Delete
            className={classNames(
              styles.icon,
              styles["icon-right"],
              styles.delete,
              styles["hover-show"]
            )}
            onClick={() => {
              onDelete?.(id);
            }}
          />
        )}
      </div>
      <div className={styles["name-and-label"]}>
        {isEdit ? (
          <Input
            ref={inputRef}
            value={editInputValue}
            onChange={(e) => {
              setEditInputValue(e.target.value);
            }}
            onBlur={modifyName}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                modifyName();
              }
            }}
            className={styles["input-name"]}
          />
        ) : (
          <Tooltip title={name} placement="bottomLeft" color="#2D3253E6">
            <div className={styles.show}>
              <div className={styles.name} onClick={editName}>
                {name}
              </div>
              {canEditName && (
                <div>
                  <EditNameIcon
                    className={styles["modify-name-icon"]}
                    onClick={editName}
                  />
                </div>
              )}
              {showCopyButton &&
                (copySuccess ? (
                  <Tooltip title="复制成功" color="#2D3253E6">
                    <CopySuccessIcon className={styles["copy-icon"]} />
                  </Tooltip>
                ) : (
                  <Tooltip title="复制" color="#2D3253E6">
                    <CopyIcon
                      className={styles["copy-icon"]}
                      onClick={() => {
                        copyData(name);
                        setCopySuccess(true);
                        setTimeout(() => {
                          setCopySuccess(false);
                        }, 2000);
                      }}
                    />
                  </Tooltip>
                ))}
            </div>
          </Tooltip>
        )}
      </div>
    </div>
  );
};

export default MaterialCard;
